import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      thresholds: {
        xl: 1300
      }
    };
  },
  computed: {
    ...mapGetters({
      windowSize: 'general/windowSize'
    }),
    xxlOnly() {
      return this.windowSize.x >= this.thresholds.xl;
    }
  }
};
